import React from 'react';
import './main.sass';
import { AllProjects } from './mainComp/allProjekts/allProjekts';
import { RegistrationForm } from './mainComp/contacts/contacts';
import { Info } from './mainComp/info/info';
import { Scills } from './mainComp/scills/scills';
import { MySlider } from './mainComp/slider/slider';

export const Main = () => {
    return(
        <div className='main'>
            <Info />
            <Scills /> 
            <MySlider />
            <AllProjects />
            <RegistrationForm />
        </div>
    )
}